import * as Yup from 'yup';

export default Yup.object().shape({
    fromDate: Yup.string().required('Start date cannot be empty').nullable(),
    toDate: Yup.string().required('End date cannot be empty').nullable()
});